import { newsData as fallbackNews, players as fallbackPlayers, galleryImages as fallbackGallery } from "./fallbackData";

/*
  Centralized data resolver that handles API vs fallback logic
  This is the only place that knows whether API exists or not
*/
export const getNewsData = async () => {
  // TEMP: API not ready - will be replaced with real API call when available
  try {
    // When API is ready, this will be the actual call:
    // const res = await fetch("/api/news");
    // const apiData = await res.json();
    // return apiData && apiData.length > 0 ? apiData : fallbackNews;
    
    // For now, return null to use fallback data
    const apiData = null;
    return apiData && apiData.length > 0 ? apiData : fallbackNews;
  } catch (error) {
    console.warn("API call failed, using fallback data:", error);
    return fallbackNews;
  }
};



/*
  Player data resolver
*/
export const getPlayerData = async () => {
  try {
    // When API is ready, this will be the actual call:
    // const res = await fetch("/api/players");
    // const apiData = await res.json();
    // return apiData && apiData.length > 0 ? apiData : fallbackPlayers;
    
    // For now, return null to use fallback data
    const apiData = null;
    return apiData && apiData.length > 0 ? apiData : fallbackPlayers;
  } catch (error) {
    console.warn("API call failed, using fallback data:", error);
    return fallbackPlayers;
  }
};

/*
  Gallery data resolver
*/
export const getGalleryData = async () => {
  try {
    // When API is ready, this will be the actual call:
    // const res = await fetch("/api/gallery");
    // const apiData = await res.json();
    // return apiData && apiData.length > 0 ? apiData : fallbackGallery;
    
    // For now, return null to use fallback data
    const apiData = null;
    return apiData && apiData.length > 0 ? apiData : fallbackGallery;
  } catch (error) {
    console.warn("API call failed, using fallback data:", error);
    return fallbackGallery;
  }
};